/* client/src/api/chatService.js */
import { getAccessToken } from '../Utilities/Api';

const API_BASE_URL = 'https://talkear.onrender.com/api';

/**
 * Core fetch wrapper with auth and error handling
 */
const handleFetch = async (url, options = {}) => {
    const token = getAccessToken();
    const defaultHeaders = {
        'Content-Type': 'application/json',
    };

    if (token) {
        defaultHeaders['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(url, {
        ...options,
        headers: {
            ...defaultHeaders,
            ...options.headers,
        },
    });

    if (!response.ok) {
        let errorData;
        try {
            errorData = await response.json();
        } catch (e) {
            errorData = { message: response.statusText };
        }
        console.error(`❌ API Error on ${options.method || 'GET'} ${url}:`, errorData.message);
        throw new Error(errorData.message || 'An unknown API error occurred.');
    }

    const text = await response.text();
    return text ? JSON.parse(text) : {};
};

/**
 * 1. Retrieves the list of all unified chats (DMs and Groups).
 */
export const getUnifiedChats = async () => {
    return handleFetch(`${API_BASE_URL}/chats`, { method: 'GET' });
};

/**
 * 2. Finds or Creates a DM with path parameters.
 * Aligns with backend: router.post('/dm/:friendId', ...)
 */
export const findOrCreateDM = async (friendId) => {
    if (!friendId) throw new Error("Friend ID is required to open a DM");

    return handleFetch(`${API_BASE_URL}/chats/dm/${friendId}`, {
        method: 'POST'
    });
};

/**
 * 3. Retrieves message history with pagination.
 */
export const getChatMessages = async (chatId, page = 1, limit = 50) => {
    if (!chatId) {
        console.warn("⚠️ getChatMessages called without chatId");
        return [];
    }
    return handleFetch(`${API_BASE_URL}/chats/${chatId}/messages?page=${page}&limit=${limit}`, {
        method: 'GET'
    });
};

/**
 * 4. Sends a message seen receipt.
 * Aligns with backend: router.post('/:chatId/seen', ...)
 */
export const markChatAsRead = async (chatId) => {
    if (!chatId) return;
    return handleFetch(`${API_BASE_URL}/chats/${chatId}/seen`, {
        method: 'POST'
    });
};